import chatbotApi from '@/api/chatbot'

const state = {
}

const actions = {
  chatbotWelcome ({ commit }, params) {
    return chatbotApi.chatbotWelcome(params)
  },

  chatbotWelcomeBack ({ commit }, jobId) {
    return chatbotApi.chatbotWelcomeBack(jobId)
  },
  chatbotStayJobDetail ({ commit }, jobId) {
    return chatbotApi.chatbotStayJobDetail(jobId)
  },
  chatbotClickApplyJobButton ({ commit }, jobId) {
    return chatbotApi.chatbotClickApplyJobButton(jobId)
  },
  chatbotOperationChatWindow ({ commit }, params) {
    return chatbotApi.chatbotOperationChatWindow(params)
  },
  chatbotManagementInfo ({ commit }) {
    return chatbotApi.chatbotManagementInfo()
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
